/** Project ID placeholder que RainbowKit/wagmi usaban cuando falta configuración real. */
export const WALLETCONNECT_PLACEHOLDER_PROJECT_ID = '00000000000000000000000000000000'

/** Lee `VITE_WALLETCONNECT_PROJECT_ID` del build (trim). */
export function getWalletConnectProjectId(): string {
  const raw = import.meta.env.VITE_WALLETCONNECT_PROJECT_ID
  return typeof raw === 'string' ? raw.trim() : ''
}

/** WalletConnect/Reown operativo solo con ID real (no placeholder ni vacío). */
export function isWalletConnectConfigured(): boolean {
  const id = getWalletConnectProjectId()
  return id.length > 0 && id !== WALLETCONNECT_PLACEHOLDER_PROJECT_ID
}
